// extracted by mini-css-extract-plugin
export default {"feeCard":"PurchaseAdviceFeeCard_feeCard__CVtMw"};